export default __webpack_public_path__ + "向左箭头.png";